export default __webpack_public_path__ + "static/media/2.2b97f3d3.svg";